import { FC, useEffect, useRef } from 'react';
import { FormikProps, useFormikContext } from 'formik';

// hooks
import useOnMount from 'hooks/useOnMount';

interface Props {
  onChange?: (values: any) => void;
  onStatusChange?: (formikProps: FormikProps<any>) => void;
  validateOnMount?: boolean;
}

const FormikEffect: FC<Props> = ({ onChange, onStatusChange, validateOnMount }) => {
  const formikProps = useFormikContext();

  const { values, isSubmitting, dirty, errors, validateForm } = formikProps;

  const isInitialRenderRef = useRef(true);

  useOnMount(() => {
    if (validateOnMount) {
      validateForm();
    }
  });

  useEffect(() => {
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false;
      return;
    }

    if (onChange) {
      onChange(values);
    }
  }, [values]);

  useEffect(() => {
    if (onStatusChange) {
      onStatusChange(formikProps);
    }
  }, [isSubmitting, dirty, errors]);

  return null;
};

export default FormikEffect;
